import React from "react";
import { Box, Typography } from "@mui/material";

import { colors } from "../dark-hero/colors";
import { HERO_PILLARS } from "./honest-buildContent";

const gridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr 1fr", md: "1fr 1fr" },
  gap: { xs: 1.25, md: 1.5 },
  width: "100%",
  textAlign: "left",
};

const itemSx = {
  px: { xs: 1.1, md: 1.35 },
  py: { xs: 1.1, md: 1.25 },
  border: `1px solid ${colors.border.default}`,
  borderRadius: "12px",
  background: "linear-gradient(180deg, rgba(255,255,255,0.035), transparent)",
  minWidth: 0,
};

const titleSx = {
  fontSize: { xs: "0.78rem", md: "0.85rem" },
  fontWeight: 700,
  letterSpacing: "-0.02em",
  color: colors.text.primary,
  lineHeight: 1.25,
};

const bodySx = {
  mt: 0.45,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  lineHeight: 1.4,
  color: colors.text.secondary,
};

export default function HeroPillars() {
  return (
    <Box sx={gridSx}>
      {HERO_PILLARS.map((pillar) => (
        <Box key={pillar.title} sx={itemSx}>
          <Typography sx={titleSx}>{pillar.title}</Typography>
          <Typography sx={bodySx}>{pillar.body}</Typography>
        </Box>
      ))}
    </Box>
  );
}
